/*
 * Copyright (c) Dito Technologies
 */

import React from "react"
import ContentWrapper from "ui/common/ContentWrapper";
import Header1 from "ui/kit/typography/Header1";
import Button from "ui/kit/buttons/Button";
import {faCheck} from "@fortawesome/free-solid-svg-icons";
import AuthenticationContext from "state/authentication";

const BackdoorLogin: React.FC = () => {
    const authenticationContext = React.useContext(AuthenticationContext);
    const [accessToken, setAccessToken] = React.useState<string>("")
    const updateAccessToken: React.ChangeEventHandler<HTMLInputElement> = React.useCallback(e => {
        setAccessToken(e.target.value)
    }, [setAccessToken]);
    const onSubmitPress = React.useCallback(() => {
        authenticationContext.setAccessToken(accessToken)
    }, [accessToken, authenticationContext]);
    return (
        <ContentWrapper>
            <Header1>Backdoor Login</Header1>
            <input value={accessToken} onChange={updateAccessToken} type={"text"} placeholder={"Paste Access Token"}/>
            <Button icon={faCheck} title={"Submit"} onClick={onSubmitPress}/>
        </ContentWrapper>
    );
}

export default BackdoorLogin;